module.exports = __webpack_public_path__ + "img/logo-26.4a8df07.jpg";